<div *ngIf="!hidden" class="p-field-checkbox" [class]="containerClass">
    <p-checkbox
            [(ngModel)]="value"
            binary="true"
            (click)="$event.stopPropagation()"
            (onChange)="onChange($event)"
            [disabled]="disabled || readonly">
    </p-checkbox>
    <div [class]="stateClass" (click)="onLabelClick()">
        <ng-content></ng-content>
    </div>
</div>
